import { z } from 'zod';

export const genderSchema = z.enum(['Male', 'Female', 'Unisex']);

export type GenderSchema = z.infer<typeof genderSchema>;
